import { useLocation } from "react-router";

const core = {
    useQuery() {
        return new URLSearchParams(useLocation().search);
    },
    formdatDate(d, f){
        const date = new Date(d);
        const format = f.toLowerCase();
        const year = date.getFullYear();
        const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
        const result = format.replace(`yyyy`, year).replace("mm", month).replace("dd", day).replace("hr", hours).replace("min", minutes).replace("sec", seconds)
        return result
    }
}

export default core;